export const SET_DASHBOARD = "SET_DASHBOARD";
export const SET_DEBTORS = "SET_DEBTORS";
export const SET_CREDITORS = "SET_CREDITORS";
export const SET_RECIEVE_CHEQUES = "SET_RECIEVE_CHEQUES";
export const SET_PAYMENT_CHEQUES = "SET_PAYMENT_CHEQUES";
export const SET_DASHBOARD_FINANCIALS = "SET_DASHBOARD_FINANCIALS";
export const SET_TOPSALES = "SET_TOPSALES";
export const SET_TOPBUYS = "SET_TOPBUYS";
export const SET_BUYFACTOR = "SET_BUYFACTOR";
export const SET_SELLFACTOR = "SET_SELLFACTOR";
export const SET_PROFIT_AND_LOSS = "SET_PROFIT_AND_LOSS";
export const SET_LATEST_ACCOUNTINGS = "SET_LATEST_ACCOUNTINGS";
export const SET_SALES_CHART = "SET_SALES_CHART";
export const SET_BUYS_CHART = "SET_BUYS_CHART";
export const SET_INCOMES_CHART = "SET_INCOMES_CHART";
export const SET_COSTS_CHART = "SET_COSTS_CHART";
